
import { controls } from "../../controls";


const loandocuments = {
  label: "Loan Action",
  pageLabel: "Loan Action",
  starting: true,
  url: "loandocuments",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [
    ...controls.displayText({ label: "Description", width: "col-sm-2" }),
    ...controls.text({ placeHolder: "description", name: "description", width: "col-sm-4" }),
    ...controls.displayText({ label: "Date", width: "col-sm-2" }),
    ...controls.datePicker({ width: "col-sm-2", name: "date" }),
   
    
    ...controls.button({
      label: "ADD", onclick: {
        action: "appendToHTMLTable",
        tableNameField: 'loandocuments_table',
        requiredField: ["description","date" ]   }, width: "col-sm-2"
    }),
    {
      inputType: "table",
      tableTitle: "",
      // convertedTo: "nominee_table",
      deletable: true,
      // editable: true,
      // addRows: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Description", field: "description" },
        { label: "Date", field: "date",displaytype:"date" }
        
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "loandocuments_table"
    },
  ]
}

export default loandocuments;